import { UiSectionGroupModel } from "../../models";

export function mockUiSectionGroupModel({
    id = "section-group-1234",
    type = "uiSectionGroup",
    locale = "en",
    content = mockUiSectionGroupModelContent()
}: Partial<UiSectionGroupModel> = {}): UiSectionGroupModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiSectionGroupModelContent = UiSectionGroupModel["content"];

export function mockUiSectionGroupModelContent({
    entryTitle = "Demo section group",
    sections = [],
    ...optionals
}: Partial<UiSectionGroupModelContent> = {}): UiSectionGroupModelContent {
    return {
        entryTitle,
        sections,
        ...optionals
    };
}
